import React, { useState } from 'react';
import { Modal, Button, Upload, message, Row, Col, Typography, Divider } from 'antd';
import { UploadOutlined, DownloadOutlined, InboxOutlined, DeleteFilled } from '@ant-design/icons';
import axios from 'axios';
import './index.css';
import { apiDownloadTemplate } from '@services/ManageDevices/DeviceServices';
import { downloadBlobFile, uploadBlobFile } from '@utils/utils';
import { URL_API } from '@configs/index';
import { showError } from '@components/notification';

const { Text } = Typography;

const ModalImportFile = ({ visible, onCancel }) => {
  const [file, setFile] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const handleDownload = async () => {
    try {
      setLoadingTemplate(true);
      await downloadBlobFile(
        `${URL_API}/api/down-link-command/export-template`,
        'File mẫu import lệnh.xlsx',
        null,
        'POST'
      );
    } catch (e) {
      showError('Có lỗi xảy ra, vui lòng liên hệ ban quản trị');
    } finally {
      setLoadingTemplate(false);
    }
  };

  const beforeUpload = (file) => {
    setFile(file);
    return false;
  };
  const [loadingImport, setLoadingImport] = useState(false);
  const handleSubmit = async () => {
    try {
      setLoadingImport(true);
      if (!file) {
        message.warning('Bạn phải chọn file trước khi nhập!');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      await uploadBlobFile(`${URL_API}/api/down-link-command/import`, 'Kết quả.xlsx', formData);
      onCancel();
    } catch (e) {
      showError('Có lỗi xảy ra, vui lòng liên hệ ban quản trị');
    } finally {
      setLoadingImport(false);
    }
  };

  const handleRemove = () => {
    setFile(null);
  };

  return (
    <Modal
      title="Nhập dữ liệu từ file excel"
      visible={visible}
      loading={loadingImport}
      onCancel={() => {
        setFile(null);
        onCancel();
      }}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          style={{
            color: '#fff',
            height: '36px',
            backgroundColor: '#0284c7',
            borderColor: '#0284c7',
            fontSize: '18px'
          }}>
          Nhập dữ liệu
        </Button>
      ]}>
      <Row gutter={[16, 16]} style={{ marginTop: '0px' }}>
        <Col span={24}>
          <Button
            loading={loadingTemplate}
            type="link"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            block
            style={{
              color: '#0284c7',
              fontSize: '18px'
            }}>
            Tải về file mẫu
          </Button>
        </Col>
        <Col span={24}>
          {!file ? (
            <Upload.Dragger beforeUpload={beforeUpload} showUploadList={false}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Nhấn hoặc thả file vào để tải lên</p>
              <p className="ant-upload-hint">Vui lòng chỉ tải file excel dạng .xlsx</p>
            </Upload.Dragger>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px 0'
              }}>
              <Text strong>{file.name}</Text>
              <Button
                type="link"
                icon={<DeleteFilled style={{ color: '#0284c7', fontSize: '18px' }} />}
                onClick={handleRemove}></Button>
            </div>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalImportFile;
